import { useSettings } from "../../../../context";
import ColorSelect from "../../../../../../../../library/color-select";
import { ColorResult } from "react-color";

const BackgroundColorConfiguration = () => {
  const { updateBackgroundSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "text") {
    return null;
  }

  const handleBackgroundColorChange = (colorResult: ColorResult) => {
    const currentColor = currentSettings.configuration.background.color;

    const isCurrentlyTransparent =
      currentColor === "transparent" || currentColor.includes(", 0)");

    const { r, g, b } = colorResult.rgb;

    const newAlpha = isCurrentlyTransparent ? 1 : colorResult.rgb.a;

    const rgbaString = `rgba(${r}, ${g}, ${b}, ${newAlpha})`;

    updateBackgroundSettings({ color: rgbaString });
  };

  const onResetBackgroundColor = () => {
    updateBackgroundSettings({ color: "transparent" });
  };

  return (
    <ColorSelect
      color={currentSettings.configuration.background.color}
      onChange={handleBackgroundColorChange}
      onReset={onResetBackgroundColor}
    />
  );
};

export default BackgroundColorConfiguration;
